import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";

export const AnalysisProgress = ({ translationKey, testId }) => {
  const { t } = useTranslation();
  const [step, setStep] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => setStep((value) => Math.min(value + 1, 4)), 3500);
    return () => clearInterval(timer);
  }, []);
  return <div data-testid={testId} role="status" className="bg-card border border-primary/30 rounded-xl p-5 space-y-3">
    <div className="flex items-center gap-3"><Loader2 className="w-5 h-5 text-primary animate-spin shrink-0" /><p className="text-sm font-medium">{t(`${translationKey}.${step}`)}</p></div>
    <div className="w-full bg-secondary rounded-full h-2.5 overflow-hidden"><div className="bg-primary h-2.5 rounded-full transition-[width] duration-700" style={{ width: `${Math.min((step + 1) * 18, 90)}%` }} /></div>
    <p className="text-xs text-muted-foreground text-center">{t("common.loadingAi")}</p>
  </div>;
};